<main class="guest detail" @change="changed()">
    <header>
        <header-component></header-component>
        <div class="nav">
            <h1>{{_('guest_title')}}</h1>
            <span class="icon back" @click="backMenu()"> chevron_left </span>
        </div>
    </header>

    <section class="navigation">
        <Pointer :total="totalPages()" :current="currentPageNo()"></Pointer>
        <h3>{{_('guest_enter')}}</h3>
        <button v-if="first" @click="showShare = true" class="request">
            {{_('request_input')}}
        </button>
    </section>
    <hr />

    <template v-if="current_page == 0">
        <section v-if="items.country">
            <h4>
                {{_('country')}}
                <span class="primary-label" v-if="items.country.required"
                    >{{ _('mandatory_field') }}</span
                >
                <button v-if="first" @click="sameToFirst('country')">
                    {{_('common_representative')}}
                </button>
            </h4>
            <label>
                <input
                    type="radio"
                    name="country"
                    value="JPN"
                    v-model="guest.country"
                />
                <span>{{_('japanese')}}</span>
            </label>
            <label>
                <input
                    type="radio"
                    name="country"
                    :checked="isForeigner(guest)"
                    @click="clickForeigner(guest)"
                />
                <span>{{_('foreigner')}}</span>
            </label>
            <p class="wrap-input select" v-if="isForeigner(guest)">
                <select v-model="guest.country">
                    <option :value="''"></option>
                    <template v-for="country in countries">
                        <option
                            v-if="country.key != 'JPN'"
                            :value="country.key"
                        >
                            {{country.name.en}}
                        </option>
                    </template>
                </select>
            </p>
            <hr />
        </section>
        <section v-if="items.name">
            <h4>
                {{_('name')}}
                <span class="primary-label" v-if="items.name.required"
                    >{{ _('mandatory_field') }}</span
                >
            </h4>
            <label class="wrap-input">
                <input
                    v-model="guest.name"
                    :placeholder="_('name_placeholder')"
                    type="text"
                    @input="fixEncode('name')"
                />
            </label>
            <hr />
        </section>
        <section v-if="items.name_kana">
            <h4>
                {{_('name_kana')}}
                <span v-if="items.name_kana.required" class="primary-label"
                    >{{ _('mandatory_field') }}</span
                >
            </h4>
            <label class="wrap-input">
                <input
                    v-model="guest.name_kana"
                    :placeholder="_('name_kana_placeholder')"
                    type="text"
                    @input="fixKana('name_kana')"
                />
            </label>
            <hr />
        </section>
        <section v-if="items.dob">
            <h4>
                {{_('dob')}}
                <span v-if="items.dob.required" class="primary-label"
                    >{{ _('mandatory_field') }}</span
                >
            </h4>
            <label class="wrap-input">
                <guest-date-picker
                    v-model="guest.dob"
                    type="date"
                    :default="defaultDob()"
                />
            </label>
            <hr />
        </section>
        <section v-if="items.sex">
            <h4>
                {{_('sex')}}
                <span v-if="items.sex.required" class="primary-label"
                    >{{ _('mandatory_field') }}</span
                >
            </h4>
            <label>
                <input type="radio" name="sex" :value="1" v-model="guest.sex" />
                <span>{{_('man')}}</span>
            </label>
            <label>
                <input type="radio" name="sex" :value="2" v-model="guest.sex" />
                <span>{{_('woman')}}</span>
            </label>
            <label>
                <input type="radio" name="sex" :value="3" v-model="guest.sex" />
                <span>{{_('other')}}</span>
            </label>
            <hr />
        </section>
        <section v-if="items.occupation">
            <h4>
                {{_('occupation')}}
                <span v-if="items.occupation.required" class="primary-label"
                    >{{ _('mandatory_field') }}</span
                >
            </h4>
            <p class="wrap-input select">
                <select v-model.number="guest.occupation_id">
                    <option :value="null"></option>
                    <template v-for="occupation in occupations">
                        <option :value="occupation.id">
                            {{ _(occupation.key) }}
                        </option>
                    </template>
                </select>
            </p>
            <label class="wrap-input" v-if="guest.occupation_id === 99">
                <input
                    v-model="guest.occupation_free_input"
                    :placeholder="_('occupation_placeholder')"
                    type="text"
                    @input="fixEncode('occupation_free_input')"
                />
            </label>
            <hr />
        </section>
    </template>

    <template v-if="current_page == 1">
        <section v-if="items.email">
            <h4>
                {{_('email')}}
                <span v-if="items.email.required" class="primary-label"
                    >{{ _('mandatory_field') }}</span
                >
                <button v-if="first" @click="sameToFirst('email')">
                    {{_('common_representative')}}
                </button>
            </h4>
            <label class="wrap-input">
                <input
                    v-model="guest.email"
                    :placeholder="_('email_placeholder')"
                    type="email"
                />
            </label>
            <hr />
        </section>
        <section v-if="items.phone">
            <h4>
                {{_('phone')}}
                <span v-if="items.phone.required" class="primary-label"
                    >{{ _('mandatory_field') }}</span
                >
                <button v-if="first" @click="sameToFirst('phone')">
                    {{_('common_representative')}}
                </button>
            </h4>
            <label class="wrap-input">
                <input
                    v-model="guest.phone"
                    :placeholder="_('phone_placeholder')"
                    type="tel"
                />
            </label>
            <hr />
        </section>
        <section v-if="items.form_memo">
            <h4>
                {{_('form_memo')}}
                <span v-if="items.form_memo.required" class="primary-label"
                    >{{ _('mandatory_field') }}</span
                >
            </h4>
            <label class="wrap-input">
                <textarea
                    v-model="guest.form_memo"
                    @input="fixEncode('form_memo')"
                ></textarea>
            </label>
            <hr />
        </section>
    </template>

    <template v-if="current_page == 2">
        <section>
            <h4 v-if="first">
                <button @click="sameToFirstAddress()">
                    {{_('common_representative')}}
                </button>
            </h4>
            <label>
                <input
                    type="radio"
                    name="country"
                    :checked="guestLiveInJapan()"
                    @click="setLiveInJapan()"
                />
                <span>{{_('living_in_japan')}}</span>
            </label>
            <label>
                <input
                    type="radio"
                    name="country"
                    :checked="!guestLiveInJapan()"
                    @click="setLiveNotJapan()"
                />
                <span>{{_('living_abroad')}}</span>
            </label>
            <hr />
        </section>
        <section v-if="items.zip_code && guestLiveInJapan()">
            <h4>
                {{_('zip_code')}}
                <span v-if="items.zip_code.required" class="primary-label"
                    >{{ _('mandatory_field') }}</span
                >
            </h4>
            <div class="flex-form zip_code-wrapper">
                <label class="wrap-input">
                    <input
                        v-model="guest.zip_code"
                        :placeholder="_('zip_code_placeholder')"
                        type="text"
                    />
                </label>
                <button
                    v-if="items.prefecture || items.addr"
                    class="auxiliary-button"
                    style="margin-left: 0"
                    @click="identifyAddr()"
                >
                    {{_('identify_addr')}}
                </button>
            </div>
            <hr />
        </section>
        <section v-if="items.prefecture && guestLiveInJapan()">
            <h4>
                {{_('prefecture')}}
                <span v-if="items.prefecture.required" class="primary-label"
                    >{{ _('mandatory_field') }}</span
                >
            </h4>
            <p class="wrap-input select" style="width: 100%; margin: 0px">
                <select v-model="guest.prefecture">
                    <option :value="null"></option>
                    <template v-for="prefecture in prefectures">
                        <option :value="prefecture.id">
                            {{prefecture.name}}
                        </option>
                    </template>
                </select>
            </p>
            <hr />
        </section>
        <section v-if="items.addr">
            <h4>
                {{_('addr')}}
                <span v-if="items.addr.required" class="primary-label"
                    >{{ _('mandatory_field') }}</span
                >
            </h4>
            <label class="wrap-input addr-input-label">
                <input
                    v-model="guest.addr"
                    :placeholder="_('addr_placeholder')"
                    type="text"
                    @input="fixEncode('addr')"
                />
            </label>
            <hr />
        </section>
    </template>

    <template v-if="current_page == 3">
        <face-check-status
            :status="imageUploadStatus"
            @close="imageUploadStatus = null"
        />
        <section v-if="items.lastplace">
            <h4>
                {{_('lastplace')}}
                <span v-if="items.lastplace.required" class="primary-label"
                    >{{ _('mandatory_field') }}</span
                >
                <button v-if="first" @click="sameToFirst('lastplace')">
                    {{_('common_representative')}}
                </button>
            </h4>
            <label class="wrap-input">
                <input
                    v-model="guest.lastplace"
                    type="text"
                    @input="fixEncode('lastplace')"
                    :placeholder="_('lastplace_placeholder')"
                />
            </label>
            <hr />
        </section>
        <section v-if="items.destination">
            <h4>
                {{_('destination')}}
                <span v-if="items.destination.required" class="primary-label"
                    >{{ _('mandatory_field') }}</span
                >
                <button v-if="first" @click="sameToFirst('destination')">
                    {{_('common_representative')}}
                </button>
            </h4>
            <label class="wrap-input">
                <input
                    v-model="guest.destination"
                    type="text"
                    @input="fixEncode('destination')"
                    :placeholder="_('destination_placeholder')"
                />
            </label>
            <hr />
        </section>
        <section v-if="items.passport_id">
            <h4>
                {{_('passport_id')}}
                <span v-if="items.passport_id.required" class="primary-label"
                    >{{ _('mandatory_field') }}</span
                >
            </h4>
            <label class="wrap-input">
                <input
                    v-model="guest.passport_id"
                    type="text"
                    @input="fixEncode('passport_id')"
                />
            </label>
            <hr />
        </section>
        <section v-if="items.passport_path">
            <h4>
                {{_('passport_path')}}
                <span v-if="items.passport_path.required" class="primary-label"
                    >{{ _('mandatory_field') }}</span
                >
            </h4>
            <p>{{ _('passport_capture_guide') }}</p>
            <div class="image-container">
                <img v-if="passport_path" :src="passport_path" />
                <div v-else class="icon">class</div>
                <div v-if="guest.passport_path" class="message">
                    {{_('uploaded')}}
                </div>
            </div>
            <div class="flex-buttons">
                <button @click="uploadImage('passport_path')" class="skeleton">
                    {{_('select_file')}}
                </button>
            </div>
            <hr />
        </section>
        <section v-if="items.face_path">
            <h4>
                {{_('face_path')}}
                <span v-if="items.face_path.required" class="primary-label"
                    >{{ _('mandatory_field') }}</span
                >
            </h4>
            <div class="image-container">
                <img v-if="face_path" :src="face_path" />
                <div v-else class="icon">person</div>
                <div v-if="guest.face_path" class="message">
                    {{_('uploaded')}}
                </div>
            </div>
            <div class="flex-buttons">
                <button @click="uploadImage('face_path')" class="skeleton">
                    {{_('select_file')}}
                </button>
            </div>
            <hr />
        </section>
        <section v-if="items.identification_path">
            <h4>
                {{_('identification_path')}}
                <span
                    v-if="items.identification_path.required"
                    class="primary-label"
                    >{{ _('mandatory_field') }}</span
                >
            </h4>
            <div class="image-container">
                <img v-if="identification_path" :src="identification_path" />
                <div v-else class="icon">picture_in_picture</div>
                <div v-if="guest.identification_path" class="message">
                    {{_('uploaded')}}
                </div>
            </div>
            <div class="flex-buttons">
                <button
                    @click="uploadImage('identification_path')"
                    class="skeleton"
                >
                    {{_('select_file')}}
                </button>
            </div>
            <hr />
        </section>
    </template>

    <template v-if="displayingInvoice()">
        <section>
            <h4>
                {{_('receipt_request')}}
                <span style="color: #ee4964">{{_('required_short')}}</span>
            </h4>
            <label>
                <input
                    type="radio"
                    :value="true"
                    v-model.boolean="invoice_issue_request.issue"
                />
                <span>{{_('necessary')}}</span>
            </label>
            <label>
                <input
                    type="radio"
                    :value="false"
                    v-model.boolean="invoice_issue_request.issue"
                />
                <span>{{_('unnecessary')}}</span>
            </label>
            <pre v-if="!invoice_issue_request.issue" class="description">
{{_('is_necessary_text')}}</pre
            >
            <div v-else class="receipt_contents">
                <section>
                    <pre>{{_('receipt_description')}}</pre>
                </section>
                <hr />
                <section>
                    <h4>{{_('receipt_address')}}</h4>
                    <pre style="color: #ee4964">
{{_('receipt_address_description')}}</pre
                    >
                    <label class="wrap-input">
                        <input v-model="invoice_issue_request.guest_name" />
                    </label>
                    <hr />
                </section>
                <section v-if="invoice_issue_items.delivery">
                    <h4>
                        {{_('invoice_delivery')}}
                        <span style="color: #ee4964"
                            >{{_('required_short')}}</span
                        >
                    </h4>
                    <label>
                        <input
                            type="radio"
                            value="1"
                            v-model.number="invoice_issue_request.delivery"
                        />
                        <span>{{_('invoice_delivery_email')}}</span>
                    </label>
                    <label>
                        <input
                            type="radio"
                            value="2"
                            v-model.number="invoice_issue_request.delivery"
                        />
                        <span>{{_('invoice_delivery_paper')}}</span>
                    </label>
                    <section>
                        <pre
                            v-if="invoice_issue_request.delivery == 1"
                            class="description"
                        >
{{_('receipt_email_description')}}</pre
                        >
                        <pre
                            v-if="invoice_issue_request.delivery == 2"
                            class="description"
                        >
{{_('receipt_paper_description')}}</pre
                        >
                        <hr />
                    </section>
                </section>
                <section v-if="invoice_issue_items.request">
                    <div>
                        <h4>{{_('invoice_request')}}</h4>
                        <label class="wrap-input">
                            <textarea
                                v-model="invoice_issue_request.request"
                            ></textarea>
                        </label>
                    </div>
                </section>
            </div>
        </section>
    </template>

    <div class="shadow flex_centered" v-if="showLine && app.getLang() === 'ja'">
        <line-modal
            :add-friends-url="app.line.add_friends_url"
            :appeal-text="app.line.appeal_text"
            :appeal-image-url="app.line.appeal_image_url"
            @close="finish()"
        ></line-modal>
    </div>

    <div class="shadow flex_centered" v-if="showShare">
        <div class="share-modal">
            <div class="share-modal-header">
                <h1>{{_('guest_information_input_form')}}</h1>
                <span class="control" @click="showShare = false">close</span>
                <hr />
            </div>
            <div class="share-modal-body">
                <a
                    :href="getShareUrl()"
                    class="share-box"
                    v-if="app.getLang() === 'ja'"
                >
                    <img src="/images/icon_line.png" />
                    <p>LINEで送る</p>
                </a>
                <div class="share-box" @click="copyUrl()">
                    <span class="icon">content_copy</span>
                    <p>{{_('copy_url')}}</p>
                </div>
            </div>
        </div>
    </div>

    <section class="flex-buttons">
        <button v-if="currentPageNo() > 1" class="skeleton" @click="back()">
            {{_('go_back')}}
        </button>
        <button v-if="totalPages() == currentPageNo()" @click="checkComplete()">
            {{_('complete')}}
        </button>
        <button v-else @click="next()">{{_('go_next')}}</button>
    </section>

    <hr />
    <section class="remarks">
        <pre>※ {{_('requesting_text')}}</pre>
    </section>
    <hr />
</main>
